import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData } from '../../../types'
import { CmsConverterService } from '../../../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class ColorContainerContentOverviewConverter extends CmsConverterService<ColorContainerContentOverviewData> {
  convertData (source: CmsComponent) {
    return {}
  }
}

export const COLOR_CONTAINER_CONTENT_OVERVIEW_CONVERTER_TOKEN =
  new InjectionToken<Converter<CmsComponent, ColorContainerContentOverviewData>>('ColorContainerContentOverviewConverter')

export type ColorContainerContentOverviewData = ConvertedComponentData
